import React from 'react'
import PropTypes from 'prop-types'

import EditableButton from '@v4/components/common/EditableButton'
import { useChangeEmailButton } from './ChangeEmailButton.hooks'

const ChangeEmailButton = props => {
	const [{ children, className, editable, rest }, { handleClick, handleChange }] = useChangeEmailButton(props)
	return (
		<EditableButton
			{...rest}
			className={className}
			onClick={handleClick}
			editable={editable}
			onChange={handleChange}
		>
			{children}
		</EditableButton>
	)
}

ChangeEmailButton.propTypes = {
	children: PropTypes.string,
	className: PropTypes.string,
	onChange: PropTypes.func,
	editable: PropTypes.bool,
	variant: PropTypes.oneOf(['filled', 'outlined']),
	color: PropTypes.oneOf(['white', 'primary', 'secondary', 'text']),
	primaryColor: PropTypes.string,
}

export default ChangeEmailButton
